import {
  forwardRef,
  useEffect,
  useImperativeHandle,
} from "react";

import { useForm } from "react-hook-form";
import { z } from "zod";
import {
  zodResolver,
} from "@hookform/resolvers/zod";

import { FormField } from "@/components/ui/FormField";

export const targetDaySchema =
  z
    .object({
      From_Day:
        z.coerce
          .number()
          .min(
            1,
            "From Day must be between 1 and 31"
          )
          .max(
            31,
            "From Day must be between 1 and 31"
          ),

      To_Day:
        z.coerce
          .number()
          .min(
            1,
            "To Day must be between 1 and 31"
          )
          .max(
            31,
            "To Day must be between 1 and 31"
          ),

      Target_Day:
        z.coerce
          .number()
          .min(
            1,
            "Target Day must be between 1 and 31"
          )
          .max(
            31,
            "Target Day must be between 1 and 31"),
    })
    // .refine(
    //   (data) =>
    //     data.To_Day >=
    //     data.From_Day,
    //   {
    //     message:
    //       "To Day must be greater than or equal to From Day",
    //     path: [
    //       "To_Day",
    //     ],
    //   }
    // )
    // .refine(
    //   (data) =>
    //     data.Target_Day >=
    //       data.From_Day &&
    //     data.Target_Day <=
    //       data.To_Day,
    //   {
    //     message:
    //       "Target Day must be within From Day and To Day",
    //     path: [
    //       "Target_Day",
    //     ],
    //   }
    // );

export type TargetDayFormData =
  z.output<
    typeof targetDaySchema
  >;

type TargetDayInput =
  z.input<
    typeof targetDaySchema
  >;

export interface AddTargetDayHandle {
  submit: () => void;
  reset: () => void;
}

interface Props {
  defaultValues?: TargetDayFormData;

  onSubmit: (
    data: TargetDayFormData
  ) => void;

  isLoading?: boolean;
}

const EMPTY_FORM: TargetDayInput =
  {
    From_Day: "",
    To_Day: "",
    Target_Day: "",
  };

const AddTargetDayForm =
  forwardRef<
    AddTargetDayHandle,
    Props
  >(
    (
      {
        defaultValues,
        onSubmit,
        isLoading,
      },
      ref
    ) => {
      const {
        control,
        handleSubmit,
        formState: {
          errors,
        },
        reset,
        clearErrors,
      } =
        useForm<
          TargetDayInput,
          unknown,
          TargetDayFormData
        >({
          resolver:
            zodResolver(
              targetDaySchema
            ),

          defaultValues:
            defaultValues ??
            EMPTY_FORM,
        });

      useEffect(() => {
        reset(
          defaultValues ??
            EMPTY_FORM
        );
      }, [
        defaultValues,
        reset,
      ]);

      useImperativeHandle(
        ref,
        () => ({
          submit:
            handleSubmit(
              onSubmit
            ),

          reset: () =>
            reset(
              EMPTY_FORM
            ),
        }),
        [
          handleSubmit,
          onSubmit,
          reset,
        ]
      );

      return (
        <form className="space-y-5">

          <FormField
            control={
              control
            }
            name="From_Day"
            label="From Day"
            type="text"
            required
            disabled={
              isLoading
            }
            error={
              errors
                .From_Day
                ?.message
            }
            onClear={() =>
              clearErrors(
                "From_Day"
              )
            }
          />

          <FormField
            control={
              control
            }
            name="To_Day"
            label="To Day"
            type="text"
            required
            disabled={
              isLoading
            }
            error={
              errors
                .To_Day
                ?.message
            }
            onClear={() =>
              clearErrors(
                "To_Day"
              )
            }
          />

          <FormField
            control={
              control
            }
            name="Target_Day"
            label="Target Day"
            type="text"
            required
            disabled={
              isLoading
            }
            error={
              errors
                .Target_Day
                ?.message
            }
            onClear={() =>
              clearErrors(
                "Target_Day"
              )
            }
          />

        </form>
      );
    }
  );

AddTargetDayForm.displayName =
  "AddTargetDayForm";

export default AddTargetDayForm;